import { store } from "../../store";


const actionPrefix = "API_";
export const NETWORK_WARNINGS_ACTIVE = actionPrefix + "NETWORK_WARNINGS_ACTIVE";
export const NETWORK_WARNINGS_INACTIVE = actionPrefix + "NETWORK_WARNINGS_INACTIVE";

let _csrtHeaderKey = undefined;
let _csrtHeaderValue = undefined;

function getCsrfHeaderPair() {
  if (_csrtHeaderKey && _csrtHeaderValue) {
    return { [_csrtHeaderKey]: _csrtHeaderValue }
  }
  return {};
}

export function getFetchConfig() {
  return {
    mode: "cors",
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...getCsrfHeaderPair()
    }
  }
}

function handleCSRFHeader(response) {
  const csrfHeaderKey = response.headers.get("X-CSRF-HEADER");
  if (csrfHeaderKey) {
    _csrtHeaderKey = csrfHeaderKey;
    _csrtHeaderValue = response.headers.get(csrfHeaderKey);
  }
  return response;
}

export function handleRawResponse(response) {
  handleCSRFHeader(response);

  if (response.ok || (response.status >= 400 && response.status < 500)) {
    return response.json();
  }

  return Promise.reject(new Error(`${response.status} ${response.statusText}`));
}

export function handleJsonResponse(response, isRawResponseOk) {
  if (response.message && !isRawResponseOk) {
    throw new Error(response.message);
  } else {
    return response;
  }
}

export function urlAddTenant(subUrl) {
  const { configuration } = store.getState();
  const tenant = configuration.tenant;
  if (!tenant) return subUrl;
  return tenant ? `/${tenant}${subUrl}` : subUrl;
}



